module.exports = __webpack_public_path__ + "static/media/value-proposition-curation@3x.12e7769d.png";